<template>
  <div class="like__dislike pr-8" v-if="checkRole(roleObj.rating)">
    <div class="like">
      <v-icon
        class="onHover raunded"
        @click="like = 1"
        :class="{ active: UserLike }"
        >fa-thumbs-up</v-icon
      >
      ({{ likes }})
    </div>
    <div class="count" :class="getLikesClass()">( {{ useful }} )</div>
    <div class="dislike">
      <v-icon
        class="onHover raunded"
        @click="like = -1"
        :class="{ active: UserDislike }"
        >fa-thumbs-down</v-icon
      >
      ({{ dislikes }})
    </div>
  </div>
  <div class="like__dislike pr-8" v-else>
    <div class="like">
      <v-icon class="disactive">fa-thumbs-up</v-icon>
      ({{ likes }})
    </div>
    <div class="count" :class="getLikesClass()">( {{ useful }} )</div>
    <div class="dislike">
      <v-icon class="disactive">fa-thumbs-down</v-icon>
      ({{ dislikes }})
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import { roleObj } from "@/plugins/roles";

export default {
  name: "likes",
  data: () => ({
    like: null,
    roleObj,
  }),
  props: {
    disabled: { type: Boolean, default: false },
    bySite: { type: Boolean, default: false },
    site_id: { type: Number },
    bank_id: { type: Number },
    product_id: { type: Number },
    user_id: { type: Number, required: true },
    useful: { type: Number, required: true },
    likes: { type: Number, required: true },
    dislikes: { type: Number, required: true },
    likesArray: {
      type: Array,
      require: true,
      default: () => {
        return [];
      },
    },
    dislikesArray: {
      type: Array,
      require: true,
      default: () => {
        return [];
      },
    },
  },
  methods: {
    getLikesClass() {
      if (this.useful >= 1) return "like";
      else if (this.useful <= -1) return "dislike";
      else return "";
    },
    async setLike() {
      if (!this.disabled) {
        if (!this.bySite) {
          if (Number(this.userId) !== Number(this.user_id)) {
            if (this.like !== null) {
              const obj = {
                actions: "set",
                bank_id: this.bank_id,
                product_id: this.product_id,
                user_id: this.user_id,
                like: this.like,
              };
              const data = await this.$store.dispatch("USERS_LIKES_BANK", obj);
              if (data.save == true) {
                this.$emit("makeInit", true);
              }
              this.like = null;
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "Ошибка",
              text: "Нельзя оценить самого себя",
            });
          }
        } else {
          if (Number(this.userId) !== Number(this.user_id)) {
            if (this.like !== null) {
              const obj = {
                actions: "set",
                site_id: this.site_id,
                user_id: this.user_id,
                like: this.like,
              };
              const data = await this.$store.dispatch("USERS_LIKES_SITE", obj);
              if (data.save == true) {
                this.$emit("makeInit", true);
              }
              this.like = null;
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "Ошибка",
              text: "Нельзя оценить самого себя",
            });
          }
        }
      }
    },
    async getLike() {
      if (!this.bySite) {
        const obj = {
          actions: "get",
          bank_id: this.bank_id,
          product_id: this.product_id,
          user_id: this.user_id,
        };
        await this.$store.dispatch("USERS_LIKES_BANK", obj);
      } else {
        const obj = {
          actions: "get",
          site_id: this.site_id,
          user_id: this.user_id,
        };
        await this.$store.dispatch("USERS_LIKES_SITE", obj);
      }
    },
  },
  computed: {
    userId() {
      return this.$store.getters.user_id;
    },
    UserLike() {
      const id = this.$store.getters.user_id;
      const find =
        this.likesArray &&
        this.likesArray.length > 0 &&
        this.likesArray.find((item) => item === Number(id));
      return find ? true : false;
    },
    UserDislike() {
      const id = this.$store.getters.user_id;
      const find =
        this.dislikesArray &&
        this.dislikesArray.length > 0 &&
        this.dislikesArray.find((item) => item === Number(id));
      return find ? true : false;
    },
  },
  watch: {
    like() {
      this.setLike();
    },
  },
};
</script>
<style lang="sass" scoped>
$likes-color: rgba(56,169,33,1)
$dislike-color: rgba(255,100,100,1)

.like__dislike
  width: 1fr
  display: grid
  grid-template-columns: 55px 1fr 55px
  justify-content: center
  align-items: end
  .count
    align-self: end
    &.like
      color: $likes-color
    &.dislike
      color: $dislike-color
  .like
    display: flex
    flex-wrap: nowrap
    align-self: end
    .raunded
      padding: 5px
      &:hover
        color: $likes-color
        transform: scale(1.1)
      &.active
        color: $likes-color
  .dislike
    display: flex
    flex-wrap: nowrap
    align-self: end
    .raunded
      padding: 5px
      &:hover
        color: $dislike-color
        transform: scale(1.1)
      &.active
        color: $dislike-color
.disactive
  padding: 5px
</style>
